export default "__VITE_ASSET__D0J9GH$e__"